module.exports = __webpack_public_path__ + "static/media/marcasAgua.237999b7.png";